// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var PfIcon = require("../../../packages/pf-icon/src/PfIcon.bs.js");
var MarkdownBlock = require("../../../shared/components/MarkdownBlock.bs.js");
var SubmissionChecklistItem = require("../types/SubmissionChecklistItem.bs.js");

function str(prim) {
  return prim;
}

function kindIconClasses(result) {
  switch (result.TAG | 0) {
    case /* ShortText */0 :
        return "if i-short-text-light text-base md:text-lg text-gray-800 mt-px";
    case /* LongText */1 :
        return "if i-long-text-light text-base md:text-lg text-gray-800 mt-px";
    case /* Link */2 :
        return "if i-link-light text-base md:text-lg text-gray-800 mt-px";
    case /* MultiChoice */4 :
        return "if i-check-circle-alt-light text-base md:text-lg text-gray-800 mt-px";
    case /* Files */3 :
    case /* AudioRecord */5 :
        return "if i-file-light text-base md:text-lg text-gray-800 mt-px";
    
  }
}

function showFiles(files) {
  return React.createElement("div", {
              className: "flex flex-wrap"
            }, files.map(function (file) {
                  return React.createElement("a", {
                              key: "file-" + SubmissionChecklistItem.fileUrl(file),
                              className: "mt-1 mr-3 flex border overflow-hidden rounded hover:shadow-md border-pink-400 bg-white text-pink-700 hover:border-pink-600 hover:text-pink-700 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                              href: SubmissionChecklistItem.fileUrl(file),
                              target: "_blank"
                            }, React.createElement("span", {
                                  className: "course-show-attachments__attachment-title rounded text-xs font-semibold inline-block whitespace-nowrap truncate w-32 md:w-42 h-full px-3 py-2 leading-loose"
                                }, SubmissionChecklistItem.fileName(file)), React.createElement("span", {
                                  className: "flex w-10 justify-center items-center p-2 bg-pink-700 text-white"
                                }, React.createElement(PfIcon.make, {
                                      className: "if i-download-regular"
                                    })));
                }));
}

function showlink(link) {
  return React.createElement("a", {
              className: "max-w-fc mt-1 mr-3 flex border overflow-hidden rounded hover:shadow-md border-indigo-400 bg-white text-indigo-700 hover:border-blue-600 hover:text-indigo-800 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
              href: link,
              target: "_blank"
            }, React.createElement("span", {
                  className: "course-show-attachments__attachment-title rounded text-xs font-semibold inline-block whitespace-nowrap truncate w-32 md:w-42 h-full px-3 py-2 leading-loose"
                }, link), React.createElement("span", {
                  className: "flex w-10 justify-center items-center p-2 bg-indigo-700 text-white"
                }, React.createElement(PfIcon.make, {
                      className: "if i-external-link-regular"
                    })));
}

function statusIcon(updateChecklistCB, status) {
  if (updateChecklistCB !== undefined) {
    return null;
  }
  switch (status) {
    case /* Passed */0 :
        return React.createElement("div", {
                    className: "flex items-center space-x-2 text-xs bg-green-100 px-1 py-px mt-1"
                  }, React.createElement(PfIcon.make, {
                        className: "if i-check-square-solid text-green-500 text-base bg-white"
                      }), React.createElement("p", undefined, "Correct"));
    case /* Failed */1 :
        return React.createElement("div", {
                    className: "flex items-center space-x-2 text-xs bg-red-100 px-1 py-px mt-px"
                  }, React.createElement(PfIcon.make, {
                        className: "if i-times-square-solid text-red-500 text-base bg-white"
                      }), React.createElement("p", undefined, "Incorrect"));
    case /* NoAnswer */2 :
        return null;
    
  }
}

function showStatus(status) {
  switch (status) {
    case /* Passed */0 :
        return React.createElement("div", {
                    className: "bg-green-200 rounded px-1 py-px text-green-800 text-tiny"
                  }, "Correct");
    case /* Failed */1 :
        return React.createElement("div", {
                    className: "bg-red-200 rounded px-1 py-px text-red-800 text-tiny"
                  }, "Incorrect");
    case /* NoAnswer */2 :
        return null;
    
  }
}

function statusButtonSelectedClasses(status, currentStatus) {
  var tmp;
  switch (currentStatus) {
    case /* Passed */0 :
        tmp = status !== 0 ? "bg-white" : "bg-green-100 hover:bg-green-100 text-green-800 hover:text-green-800 border-green-500 z-10";
        break;
    case /* Failed */1 :
        tmp = status !== 1 ? "bg-white" : "bg-red-100 hover:bg-red-100 text-red-700 hover:text-red-700 border-red-500 z-10";
        break;
    case /* NoAnswer */2 :
        tmp = "bg-white";
        break;
    
  }
  return "inline-flex items-center cursor-pointer leading-tight font-semibold inline-block text-xs relative hover:bg-gray-100 hover:text-gray-700 " + tmp;
}

function statusButtonIcon(bool) {
  if (bool) {
    return "if i-times-square-solid text-base if-fw";
  } else {
    return "if i-square-regular text-base if-fw text-gray-500";
  }
}

function statusButtonOnClick(bool, callback, checklist, index, _event) {
  if (bool) {
    return Curry._1(callback, SubmissionChecklistItem.makeNoAnswer(index, checklist));
  } else {
    return Curry._1(callback, SubmissionChecklistItem.makeFailed(index, checklist));
  }
}

function statusButton(index, status, callback, checklist) {
  var partial_arg = status === /* Failed */1;
  return React.createElement("div", {
              className: "mt-2"
            }, React.createElement("button", {
                  className: "border border-gray-500 rounded focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 " + statusButtonSelectedClasses(/* Failed */1, status),
                  onClick: (function (param) {
                      return statusButtonOnClick(partial_arg, callback, checklist, index, param);
                    })
                }, React.createElement("span", {
                      className: "w-8 p-2 border-r border-gray-500 flex items-center justify-center"
                    }, React.createElement(PfIcon.make, {
                          className: status === /* Failed */1 ? "if i-times-square-solid text-base if-fw" : "if i-square-regular text-base if-fw text-gray-500"
                        })), React.createElement("span", {
                      className: "p-2"
                    }, status === /* Failed */1 ? "Mark as correct" : "Mark as incorrect")));
}

function cardHeaderClasses(pending) {
  return "text-sm font-semibold flex items-center justify-between " + (
          pending ? "" : "bg-white rounded"
        );
}

function cardBodyClasses(pending) {
  return "pl-7 md:pl-8 " + (
          pending ? "" : "rounded-b"
        );
}

function SubmissionChecklistItemShow(Props) {
  var index = Props.index;
  var checklistItem = Props.checklistItem;
  var updateChecklistCB = Props.updateChecklistCB;
  var checklist = Props.checklist;
  var pending = Props.pending;
  var status = SubmissionChecklistItem.status(checklistItem);
  var text = SubmissionChecklistItem.result(checklistItem);
  var tmp;
  switch (text.TAG | 0) {
    case /* LongText */1 :
        tmp = React.createElement(MarkdownBlock.make, {
              markdown: text._0,
              profile: /* Permissive */0
            });
        break;
    case /* Link */2 :
        tmp = showlink(text._0);
        break;
    case /* Files */3 :
        tmp = showFiles(text._0);
        break;
    case /* ShortText */0 :
    case /* MultiChoice */4 :
        tmp = React.createElement("div", undefined, text._0);
        break;
    case /* AudioRecord */5 :
        tmp = React.createElement("audio", {
              controls: true,
              src: text._0.url
            });
        break;
    
  }
  return React.createElement("div", {
              "aria-label": SubmissionChecklistItem.title(checklistItem)
            }, React.createElement("div", {
                  className: cardHeaderClasses(pending)
                }, React.createElement("div", {
                      className: "flex flex-1 items-start justify-between"
                    }, React.createElement("div", {
                          className: "flex items-start"
                        }, React.createElement(PfIcon.make, {
                              className: kindIconClasses(SubmissionChecklistItem.result(checklistItem))
                            }), React.createElement("p", {
                              className: "ml-3 pr-2 tracking-wide"
                            }, SubmissionChecklistItem.title(checklistItem))), statusIcon(updateChecklistCB, status))), React.createElement("div", {
                  className: "pl-7 mt-2 text-sm"
                }, React.createElement("div", undefined, tmp), updateChecklistCB !== undefined ? statusButton(index, status, updateChecklistCB, checklist) : null));
}

var ChecklistItem;

var make = SubmissionChecklistItemShow;

exports.ChecklistItem = ChecklistItem;
exports.str = str;
exports.kindIconClasses = kindIconClasses;
exports.showFiles = showFiles;
exports.showlink = showlink;
exports.statusIcon = statusIcon;
exports.showStatus = showStatus;
exports.statusButtonSelectedClasses = statusButtonSelectedClasses;
exports.statusButtonIcon = statusButtonIcon;
exports.statusButtonOnClick = statusButtonOnClick;
exports.statusButton = statusButton;
exports.cardHeaderClasses = cardHeaderClasses;
exports.cardBodyClasses = cardBodyClasses;
exports.make = make;
/* react Not a pure module */
